import { z } from 'zod';
import { getRoleMWModulesSchema } from './getRoleMWModules';

export const getRoleDetailsSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
  isFromManager: z.boolean(),
  isActive: z.boolean(),
  deleted: z.boolean(),
  roleMWModules: getRoleMWModulesSchema,
});

export type GetRoleDetailsResponse = z.infer<typeof getRoleDetailsSchema>;
